export const toCompanies = companies =>
  companies.map(company => {
    return {
      companyId: company.value,
      dueDate: company.dueDate,
      followUpDate: company.followUpDate,
      dealContacts: toContacts(company.selectedContacts || [])
    }
  })

const toContacts = contacts =>
  contacts.map(contact => {
    let role = contact.role || null
    if (typeof contact.role === 'object' && contact.role !== null) {
      role = contact.role.value
    }
    return {
      contactId: contact.value,
      isMain: contact.isMain || false,
      role
    }
  })

export const toDeal = deal => {
  return {
    address: deal.address,
    address2: deal.address2,
    street2: deal.street2,
    city: deal.city,
    name: deal.name,
    state: deal.state,
    zipCode: deal.zipCode,
    country: deal.country,
    dealCompanies: toCompanies(deal.clients),
    latitude: deal.latitude,
    longitude: deal.longitude,
    workType: deal.workType ? deal.workType.value : null,
    dealManagerId: deal.dealmanagerid ? deal.dealmanagerid.value : null,
    bidStatus: deal.bidStatus ? deal.bidStatus.value : null,
    internalBidStatus: deal.internalBidStatus ? deal.internalBidStatus.value : null,
    dealCategory: deal.dealCategory ? deal.dealCategory.code : null,
    dealStatus: deal.dealStatus ? deal.dealStatus.value : null,
    dealSource: deal.dealSource ? deal.dealSource.code : null,
    size: deal.size ? deal.size.value : null,
    briefNote: deal.briefNote,
    description: deal.description,
    hardBid: deal.hardBid,
    sealedBid: deal.sealedBid,
    prevailingWage: deal.prevailingWage,
    dueDate: deal.dueDate,
    teams: deal.teams ? deal.teams.map(t => t.value) : null,
    linkToPlans: deal.linkToPlans,
    quoteNumber: deal.quoteNumber,
    value: deal.value
  }
}

export const toBoardData = (deals, statuses) => {
  const getLaneDeals = id => {
    return deals[id] || []
  }
  const lanes = []
  statuses
    .sort((a, b) => a.orderIndex - b.orderIndex)
    .forEach(status => {
      if (status.visibleOnBoardLanes) {
        lanes.push({
          id: status.code,
          title: status.name,
          cards: getLaneDeals(status.code),
          style: { borderTop: `4px solid ${status.color || status.category.color}` }
        })
      }
    })

  return {
    lanes
  }
}

export const toDealsSelect = deals => {
  return deals.map(deal => {
    return {
      value: deal.id,
      label: deal.name
    }
  })
}

export const makeIdsString = items =>
  items.map(i => ({
    ...i,
    id: String(i.id)
  }))
